import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=1b503546&scoped=true&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=1b503546&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b503546",
  null
  
)

export default component.exports